import { Fence } from 'logic/reports/ReportSettings';
import { Size } from 'types';

export const extractFences = (xml: string, imageSize: Size): Fence[] => {
    let match = /<Mask Name="CountFence">(.*?)<\/Mask>/.exec(xml);
    if (!match) return [];
    const maskXml = match[1];

    let scaleX = 1;
    let scaleY = 1;
    match = /<Resolution width="(\d+)" height="(\d+)"/i.exec(maskXml);
    if (match) {
        const width = parseInt(match[1], 10);
        const height = parseInt(match[2], 10);
        scaleX = imageSize.width / width;
        scaleY = imageSize.height / height;
    }

    match = /<Fence.*?>(.*?)<\/Fence>/.exec(maskXml);
    if (!match) return [];
    const fenceXml = match[1];

    const fences: Fence[] = [];

    const lineRegex = /<Line (.*?)\/>/gm;
    while ((match = lineRegex.exec(fenceXml)) !== null) { // tslint:disable-line:no-conditional-assignment
        const lineAttributes =
            match[1]
                .split(' ')
                .reduce((obj, pair) => {
                    const [ Attr, quotedValue ] = pair.split('=');
                    const attr = Attr.toLowerCase();
                    const value = parseInt(quotedValue.replace('"', ''), 10);
                    const scaledValue = value * (attr[0] === 'x' ? scaleX : scaleY);
                    obj[attr] = Math.round(scaledValue);
                    return obj;
                }, {} as Fence);
        
        fences.push(lineAttributes);
    }

    return fences;
};



// WEBPACK FOOTER //
// ./src/logic/addOnConfig/extractFences.ts